import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";

export default function AdminGuard() {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main style={{ padding: "6rem var(--page-px)" }}>
        <p className="mono-tag">// cargando sesión…</p>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return (
      <main style={{ padding: "6rem var(--page-px)", maxWidth: 720 }}>
        <p className="mono-tag">// 403 — acceso restringido</p>
        <h1 style={{ fontSize: "var(--step-3)", marginTop: "0.5rem" }}>
          Tu cuenta no tiene permisos de administración.
        </h1>
        <p style={{ color: "var(--color-ink-soft)", marginTop: "1rem" }}>
          Solicita al propietario que ejecute{" "}
          <code>npm run set-admin -- tu-correo@dominio.com</code> y vuelve a
          iniciar sesión.
        </p>
      </main>
    );
  }

  return <Outlet />;
}
